import { render, staticRenderFns } from "./ColumnBoolean.vue?vue&type=template&id=77a7f00d&"
import script from "./ColumnBoolean.vue?vue&type=script&lang=ts&"
export * from "./ColumnBoolean.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports